import { FC, memo } from 'react';

import { IconBase, IconBaseProps, matchSize } from './IconBase';

const IconPlusSmall: FC<IconBaseProps> = memo(props => {
  return (
    <IconBase {...props} width="18" height="18" viewBox="0 0 18 18">
      <path d="M9 18V0M0 9H18" stroke="black" strokeWidth="2" />
    </IconBase>
  );
});

const IconPlusLarge: FC<IconBaseProps> = memo(props => {
  return (
    <IconBase {...props} width="36" height="36" viewBox="0 0 36 36">
      <path d="M18 36V0M0 18H36" stroke="black" strokeWidth="2" />
    </IconBase>
  );
});

export const IconPlus: FC<IconBaseProps> = memo(props => {
  const { size } = props;
  const Icon = matchSize(size, {
    s: IconPlusSmall,
    otherwise: IconPlusLarge,
  });

  return <Icon {...props} />;
});
